// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container-description{\n  max-height: 250px;\n  overflow-y: scroll;\n}\n.img-batch {\n  width: 200px;\n  -webkit-box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);\n}\n[dir] .img-batch {\n          box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);\n}\n", ""]);
// Exports
module.exports = exports;
